var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { Card } from "../../Card";
/**
 * This is a utility wrapper component for rendering things within the `Dashboard` component.
 * The props should be used to control how much of the `Dashboard` Grid the component should take up,
 * with some consistent responsive styles that are included here.
 */
export const DashboardItem = (_a) => {
    var { columnSpan, rowSpan, children } = _a, props = __rest(_a, ["columnSpan", "rowSpan", "children"]);
    return (React.createElement(DashboardCard, Object.assign({ rowSpan: rowSpan, columnSpan: columnSpan }, props), children));
};
const DashboardCard = styled(Card) `
  @media screen and (min-width: ${({ theme: { breakpoints } }) => breakpoints[3]}) {
    min-height: 254px;
    grid-row: ${({ rowSpan }) => (rowSpan ? `auto / span ${rowSpan}` : "auto")};
    grid-column: ${({ columnSpan }) => (columnSpan ? `auto / span ${columnSpan}` : "auto")};
  }
`;
